export enum ConjunctionMode {
  AND = "AND",
  OR = "OR",
}
